import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { Retencion } from './retencion';
import { RetencionDetalle } from './retencionDetalle';

@Injectable({
  providedIn: 'root'
})
export class RetencionComprasService {

  
  constructor(private http: HttpClient) { }

  setActulizarRetencion(retencion: Retencion){

    return this.http.put<Retencion>(environment.apiUrl+"/actulizarRetencion",retencion);
  }



}
